// Imports
import DOMPurify from 'dompurify';


// Options
export interface SanitizeOptions {
	/** Tags to be allowed on top of the default allowed tags. */
	extendAllowedTags?: string[];
}


/** Sanitize unsafe HTML */
export default function sanitizeHTML(unsafeHTML: string, options?: SanitizeOptions): string {
	// Remove children from iFrames to avoid DOMPurify removing them entirely
	DOMPurify.addHook('uponSanitizeElement', (currentNode) => {
		if (currentNode.tagName === 'IFRAME') {
			currentNode.replaceChildren();
		}
		
		return currentNode;
	});
	
	
	// Return sanitized HTML
	return DOMPurify.sanitize(unsafeHTML, { ADD_TAGS: options?.extendAllowedTags, ADD_ATTR: ['target'] });
}
